import { atom } from 'recoil';

import { StoreOrderInCart } from '~/types/cart';

const enterpriseGroupBuyOrdersAtom = atom<Array<StoreOrderInCart>>({
  key: 'enterpriseGroupBuyOrders',
  default: [],
});

export default enterpriseGroupBuyOrdersAtom;
